export default "__VITE_ASSET__Cwt25w4D__"